import {createReducer, on} from '@ngrx/store';
import {INITIAL_LOAD_STATUS_SUBSTATE, LoadStatusSubstate} from '@aviary/store/store.types';
import {FAILED, LOADED, LOADING} from '@aviary/store/common/common.types';
import {Notification} from '@store/notifications/notifications.types';
import {NotificationsActions} from '@store/notifications/notifications.actions';

export interface NotificationsState {
  notifications: LoadStatusSubstate & {
    unread: Notification[]
  };
}

export const INITIAL_NOTIFICATIONS_STATE: NotificationsState = {
  notifications: {
    ...INITIAL_LOAD_STATUS_SUBSTATE,
    unread: []
  }
};

export const notificationsState = createReducer(
  INITIAL_NOTIFICATIONS_STATE,
  on(NotificationsActions.loadNotifications, state => ({
    ...state,
    notifications: {
      loadStatus: LOADING,
      unread: []
    }
  })),
  on(NotificationsActions.loadNotificationsSuccess, (state, {notifications}) => ({
    ...state,
    notifications: {
      loadStatus: LOADED,
      unread: notifications
    }
  })),
  on(NotificationsActions.loadNotificationsFailure, state => ({
    ...state,
    notifications: {
      ...state.notifications,
      loadStatus: FAILED
    }
  })),
);
